import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import Services from './components/Services';
import Products from './components/Products';
import Testimonials from './components/Testimonials';
import { Blogs, Recipes } from './components/BlogsRecipes';
import Footer from './components/Footer';
import BookingModal from './components/BookingModal';
import CartDrawer from './components/CartDrawer';
import { Toaster } from './components/ui/toaster';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import Quiz from './pages/Quiz';
import Checkout from './pages/Checkout';
import AuthCallback from './pages/AuthCallback';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';
import { RecipesIndex, RecipeDetail } from './pages/Recipes';
import { Privacy, Terms, Refunds } from './pages/LegalPages';
import { Kharadi, Baner, Hinjewadi, Mumbai } from './pages/DietitianKharadi';
import LeadMagnetPopup from './components/LeadMagnetPopup';
import Seo from './components/Seo';

const Home = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('book') === '1') {
      setOpen(true);
      // clean the URL
      window.history.replaceState({}, '', '/');
    }
  }, [location.search]);

  const homeJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'NutrifyMe by Dietitian Prachi',
    description: 'Personalised, science-backed nutrition programs for PCOS, weight loss, gut health, diabetes, pregnancy and more.',
    priceRange: '₹₹',
    address: { '@type': 'PostalAddress', addressLocality: 'Pune', addressRegion: 'MH', addressCountry: 'IN' },
    aggregateRating: { '@type': 'AggregateRating', ratingValue: '4.9', reviewCount: '10000' },
    url: '/',
  };
  return (
    <div className="min-h-screen bg-[#faf7f1]">
      <Seo
        title="Personalised Nutrition That Actually Works"
        description="Science-backed Indian diet plans for weight loss, PCOS, diabetes, pregnancy and gut health. 10,000+ transformations across India, UAE, US & UK."
        keywords={['dietitian india', 'nutritionist pune', 'pcos diet plan', 'weight loss diet', 'best online dietitian', 'indian diet plan']}
        path="/"
        jsonLd={homeJsonLd}
      />
      <Navbar onBook={() => setOpen(true)} />
      <Hero onBook={() => setOpen(true)} />
      <Features />
      <About onBook={() => setOpen(true)} />
      <Services onBook={() => setOpen(true)} />
      <Products />
      <Testimonials />
      <Recipes />
      <Blogs />
      <Footer onBook={() => setOpen(true)} />
      <BookingModal open={open} onClose={() => setOpen(false)} />
    </div>
  );
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/quiz" element={<Quiz />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/refunds" element={<Refunds />} />
      <Route path="/dietitian-in-kharadi-pune" element={<Kharadi />} />
      <Route path="/dietitian-in-baner-pune" element={<Baner />} />
      <Route path="/dietitian-in-hinjewadi-pune" element={<Hinjewadi />} />
      <Route path="/dietitian-in-mumbai" element={<Mumbai />} />
      <Route path="/recipes" element={<RecipesIndex />} />
      <Route path="/recipes/:slug" element={<RecipeDetail />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <CartProvider>
              <AppRouter />
              <CartDrawer />
              <LeadMagnetPopup />
              <Toaster />
            </CartProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
